const permissionMatchesQuery = (node, query) => {
  const q = (query || '').trim().toLowerCase();
  if (!q) return true;

  const selfMatch = node.text.toLowerCase().includes(q)
    || (node.description || '').toLowerCase().includes(q);
  if (selfMatch) return true;

  return (node.children || []).some(child => permissionMatchesQuery(child, q));
};

export default permissionMatchesQuery;
